import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Button } from '../../components/common'
import { useAuthStore, useFavoritiStore, useLocaliStore } from '../../store'

/**
 * Pagina profilo utente
 */
export default function Profilo() {
  const navigate = useNavigate()
  const { utente, logout } = useAuthStore()
  const { favoritiIds, loadFavoriti } = useFavoritiStore()
  const { locali, fetchLocali } = useLocaliStore()

  // Carica favoriti
  useEffect(() => {
    loadFavoriti()
    fetchLocali()
  }, [loadFavoriti, fetchLocali])

  // Locali preferiti
  const localiPreferiti = locali.filter(l => favoritiIds.includes(l.id))

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  if (!utente) return null

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Header profilo */}
      <div className="bg-night-light border border-gray-800 rounded-xl p-6 mb-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-4">
            {/* Avatar */}
            <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center">
              <span className="text-night font-display text-2xl">
                {utente.nome.charAt(0).toUpperCase()}
              </span>
            </div>
            <div>
              <h1 className="font-display text-2xl text-white">
                {utente.nome} {utente.cognome}
              </h1>
              <p className="text-gray-400">{utente.email}</p>
              {utente.ruolo === 'admin' && (
                <span className="inline-block mt-1 px-2 py-0.5 bg-gold/20 text-gold text-xs rounded">
                  Admin
                </span>
              )}
            </div>
          </div>
          <div className="flex gap-3">
            {utente.ruolo === 'admin' && (
              <Link to="/admin">
                <Button variant="secondary">Pannello Admin</Button>
              </Link>
            )}
            <Button variant="danger" onClick={handleLogout}>
              Esci
            </Button>
          </div>
        </div>
      </div>

      {/* Locali preferiti */}
      <section>
        <h2 className="font-display text-2xl text-white mb-6">
          I tuoi preferiti ({localiPreferiti.length})
        </h2>

        {localiPreferiti.length === 0 ? (
          <div className="bg-night-light border border-gray-800 rounded-xl p-8 text-center">
            <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h3 className="text-lg text-white mb-2">Nessun preferito</h3>
            <p className="text-gray-400 mb-4">
              Esplora i locali e clicca sul cuore per aggiungerli ai preferiti
            </p>
            <Link to="/locali">
              <Button variant="primary">Scopri i locali</Button>
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {localiPreferiti.map(locale => (
              <Link
                key={locale.id}
                to={`/locale/${locale.slug}`}
                className="bg-night-light border border-gray-800 rounded-xl p-4 hover:border-gold/50 transition-colors"
              >
                <h3 className="font-display text-lg text-white mb-1">
                  {locale.nome}
                </h3>
                <p className="text-sm text-gray-400 mb-2">
                  {locale.comune}, {locale.provincia}
                </p>
                <div className="flex flex-wrap gap-1">
                  {locale.specialita.slice(0, 2).map((spec, i) => (
                    <span key={i} className="text-xs bg-gold/10 text-gold px-2 py-0.5 rounded">
                      {spec}
                    </span>
                  ))}
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  )
}
